import {
    SET_PATH,
    CLEAR_PATH,
} from 'store/actions/types';

const initialState = {
    path: '/',
};

export default function pathReducer(state = initialState, action) {
    switch (action.type) {
        case SET_PATH:
            return {
                ...state,
                path: action.payload,
            };

        case CLEAR_PATH:
            return initialState;

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/pathReducer.js